<template>
  <div class="manual-runes-description">
    <ManualText class="manual-runes-description__text">
      <!-- <span class="text-orange font-weight-black">Текст</span> — про порядок
      выведения рун<br />
      от
      <span class="text-orange font-weight-bold">Red Bull</span> и
      <span class="text-orange font-weight-bold">“developer name”</span> в игре
      <span class="text-orange font-weight-bold">Dota2</span>, который позволяет
      получить от игры более яркие эмоции и поучаствовать в зрелищных сражениях
      на одинаковых героях -->

      <span class="text-orange font-weight-bold">Основное:</span><br />
      &bull; Средняя продолжительность 5-15 минут<br />
      &bull; Тип PvP<br />
      &bull; Количество игроков 2<br />
      &bull; Режим 1&nbsp;против 1<br />
      <br />
      <span class="text-orange font-weight-bold">Настройки:</span><br />
      &bull; Игроки сразу начинают с&nbsp;&laquo;Bottle&raquo; , &laquo;Blink
      Dagger&raquo; и&nbsp;&laquo;Observer Ward&raquo; в&nbsp;инвентаре<br />
      &bull; Руны с&nbsp;вероятностью в&nbsp;50% появляются в&nbsp;верхних
      и&nbsp;нижних точках каждую минуту.<br />
      &bull; Через 7&nbsp;минут вместо рун начинают появляться улучшенные
      руны<br />
      &bull; Каждый игрок получает по&nbsp;одинаковому случайному предмету
      на&nbsp;5&nbsp;и&nbsp;10&nbsp;минуте.<br />
      &bull; &laquo;Divine rapier&raquo; появляется на&nbsp;башне каждого игрока
      через 15&nbsp;минут<br />
      <br />
      <span class="text-orange font-weight-bold">Новые дополнения:</span><br />
      &bull; Морозная руна<br />
      &bull; Информационный дисплей с&nbsp;отображением следующего выпадающего
      предмета и&nbsp;появления рун<br />
      &bull; интерактивная вкладка &laquo;Информация о&nbsp;режиме
      игры&raquo;<br />
      <br />
      <span class="text-orange font-weight-bold">Иное:</span><br />
      &bull; Нейтральные крипы не&nbsp;спавнятся<br />
      &bull; Святыни (по&nbsp;одной для каждого игрока) отключены<br />
      &bull; &laquo;Roshan&raquo; отсутствует на&nbsp;карте<br />
      &bull; Время возрождения 5&nbsp;секунд<br />
      &bull; За&nbsp;убийства вам&nbsp;не&nbsp;начисляется&nbsp;XP или золото<br />
    </ManualText>
  </div>
</template>

<script>
import ManualText from "./ManualText";

export default {
  name: "ManualDescription",
  components: {
    ManualText
  }
};
</script>

<style lang="scss">
.manual-runes-description {
  margin: 60px 0;
  background: url("~@/assets/img/manual/bg-runes.png") 50% 0 no-repeat;

  &__text {
    text-align: left;
  }

  @include breakpoint("sm-and-down") {
    margin: 40px 0;
  }

  @include breakpoint("xs-only") {
    background-size: cover;
  }
}
</style>
